/**
 * Декоративная подпись под названием на плитке выбора подтипа (не влияет на цену и калькулятор).
 * Админ: option_schema.tile_hint
 */

export type TileHintSource = {
  tile_hint?: string | null;
  /** Только для авто-подписи «N вар.», если админ не задал свой текст */
  variants_count?: number;
};

export function resolveConfiguratorTileHint(
  source: TileHintSource,
  fallback?: string,
): string | undefined {
  const custom = (source.tile_hint ?? '').trim();
  if (custom) return custom;

  const count = Number(source.variants_count ?? 0);
  if (count > 0) return `${count} вар.`;

  const fb = (fallback ?? '').trim();
  return fb || undefined;
}
